export default {
  首页: "Strona główna",
  资产: "Aktywa",
  币币: "Spot",
  快捷买币: "Szybki zakup kryptowalut",
  "支持多种方式购买，购买更简单": "Kupuj łatwo za pomocą wielu metod płatności",
  语言设置: "Ustawienia języka",
  确认恢复: "Potwierdź odzyskiwanie",
  "输入邮箱，方便我们联系您":
    "Wprowadź swój adres e-mail, abyśmy mogli się z Tobą skontaktować",
  划转: "Przenieś",
  行情: "Rynek",
  "24H成交": "Wolumen 24h",
  累计收益: "Całkowity zysk",
  充值时间: "Data wpłaty",
  到期时间: "Data wygaśnięcia",
  数量: "Ilość",
  操作: "Akcja",
  资产信息: "Informacje o aktywach",
  复制地址: "Kopiuj adres",
  链名称: "Nazwa łańcucha",
  充值地址: "Adres wpłaty",
  收款地址: "Adres odbioru",
  账单: "Rachunek",
  提现金额: "Kwota wypłaty",
  接收地址: "Adres odbioru",
  交易密码: "Hasło transakcyjne",
  提现全部: "Wypłać wszystko",
  保存图片: "Zapisz obraz",
  输入您的交易密码: "Wprowadź swoje hasło transakcyjne",
  确定: "Potwierdź",
  地址: "Adres",
  注册时间: "Data rejestracji",
  取消: "Anuluj",
  是否划转: "Przenieść?",
  登录: "Zaloguj się",
  我的地址: "Moje adresy",
  登录密码和交易密码: "Hasło logowania i hasło transakcyjne",
  注册: "Zarejestruj się",
  密码: "Hasło",
  设置密码: "Ustaw hasło",
  重复密码: "Powtórz hasło",
  新密码: "Nowe hasło",
  确认新密码: "Potwierdź nowe hasło",
  充值: "Wpłać",
  充值货币: "Wpłać walutę",
  合约账户充值: "Wpłać na konto futures",
  账户充值: "Wpłać na konto",
  其他: "Inne",
  我的邀请码: "Mój kod zaproszenia",
  提现: "Wypłać",
  客服: "Obsługa klienta",
  持有详情: "Szczegóły posiadania",
  请输入内容: "Wprowadź treść",
  邀请好友来领取奖励: "Zaproś znajomych i odbierz nagrody",
  复制链接: "Kopiuj link",
  重复设置新的密码: "Powtórz nowe hasło",
  保存: "Zapisz",
  我的: "Moje konto",
  "邮箱/手机号": "E-mail/Numer telefonu",
  备注: "Uwaga",
  地址管理: "Zarządzanie adresami",
  我的团队: "Mój zespół",
  联系我们: "Skontaktuj się z nami",
  竭诚为您服务: "Jesteśmy do Twojej dyspozycji",
  提取收益: "Wypłać zysk",
  带给我的收益: "Wygenerowany zysk",
  添加: "Dodaj",
  名称: "Nazwa",
  添加地址: "Dodaj adres",
  修改地址: "Zmień adres",
  可提现: "Możliwość wypłaty",
  安全中心: "Centrum bezpieczeństwa",
  收益划转: "Przenieś zysk",
  通知中心: "Powiadomienia",
  "累计收益:": "Całkowity zysk:",
  注册用户: "Zarejestrowani użytkownicy",
  奖励规则: "Zasady nagradzania",
  帮助反馈: "Pomoc i opinie",
  邀请好友: "Zaproś znajomych",
  恢复身份: "Odzyskaj tożsamość",
  选择语言: "Wybierz język",
  设置新的密码: "Ustaw nowe hasło",
  暂无活动: "Brak aktywnych aktywności",
  "月增长量(+)": "Miesięczny wzrost (+)",
  可提取: "Możliwość wypłaty",
  反馈类型: "Typ opinii",
  赠送: "Prezent",
  已经复制: "Skopiowano",
  保存成功: "Zapisano pomyślnie",
  划转成功: "Przeniesiono pomyślnie",
  过期: "Wygasło",
  提交成功: "Wysłano pomyślnie",
  "服务器繁忙，稍后在试": "Serwer jest zajęty, spróbuj ponownie później",
  全部: "Wszystkie",
  一级: "Poziom 1",
  二级: "Poziom 2",
  三级: "Poziom 3",
  级: "Poziom",
  删除成功: "Usunięto pomyślnie",
  选择地址: "Wybierz adres",
  不再提醒: "Nie pokazuj ponownie",
  "最小充值金额：": "Minimalna kwota wpłaty:",
  选择币种: "Wybierz kryptowalutę",
  输入投资金额: "Wprowadź kwotę inwestycji",
  输入账户密码: "Wprowadź hasło konta",
  投资: "Inwestuj",
  订单编号: "Numer zamówienia",
  投资周期: "Okres inwestycji",
  投资资金: "Zainwestowana kwota",
  投资时间: "Czas inwestycji",
  状态: "Status",
  投资中: "Aktywny",
  已到期: "Wygasło",
  暂无数据: "Brak danych",
  转入: "Przenieś do",
  邮箱: "E-mail",
  请输入邮箱: "Wprowadź adres e-mail",
  请输入格式正确的邮箱: "Wprowadź poprawny adres e-mail",
  请输入验证码: "Wprowadź kod weryfikacyjny",
  获取验证码: "Uzyskaj kod weryfikacyjny",
  请输入邀请码: "Wprowadź kod zaproszenia",
  今天: "Dzisiaj",
  昨天: "Wczoraj",
  最近七天: "Ostatnie 7 dni",
  邀请: "Zaproś",
  购买数量: "Ilość zakupu",
  产品详情: "Szczegóły produktu",
  币种: "Kryptowaluta",
  利息币种: "Waluta zysku",
  理财类型: "Rodzaj produktu finansowego",
  产品费率: "Opłaty produktu",
  进行中: "Aktywny",
  每天: "Codziennie",
  请输入搜索关键词: "Wprowadź słowo kluczowe",
  通知: "Powiadomienia",
  查看更多: "Zobacz więcej",
  理财宝: "Produkty finansowe",
  周期: "Okres",
  年利率: "Roczna stopa procentowa (APY)",
  更多产品: "Więcej produktów",
  灵活存取: "Elastyczne oszczędzanie",
  稳定收益: "Stabilny zysk",
  合约指南: "Przewodnik po kontraktach futures",
  资金划转出: "Przelew wychodzący",
  矿池收益: "Nagroda za wydobycie",
  提现手续费: "Opłata za wypłatę",
  冻结资金: "Zamrożone środki",
  解冻资金: "Odmrożenie zamrożonych środków",
  闪兑支出: "Wydatek na szybką wymianę",
  闪兑收入: "Przychód z szybkiej wymiany",
  闪兑手续费: "Opłata za szybką wymianę",
  合约支出: "Wydatek na futures",
  合约收入: "Przychód z futures",
  输入的金额不可大于可用金额: "Kwota nie może być większa niż dostępna kwota",
  全部兑换成功: "Pełna wymiana zakończona sukcesem",
  返回: "Wróć",
  查看历史: "Zobacz historię",
  闪兑历史: "Historia szybkiej wymiany",
  支付: "Zapłać",
  获取: "Uzyskaj",
  时间: "Czas",
  手续费: "Opłata transakcyjna",
  折扣: "Rabat",
  价格: "Cena",
  逐仓: "Izolowany depozyt zabezpieczający",
  全仓: "Krzyżowy depozyt zabezpieczający",
  市价委托: "Zlecenie rynkowe",
  限价委托: "Zlecenie limitowane",
  请输入本金: "Wprowadź kwotę główną",
  请输入价格: "Wprowadź cenę",
  "可做空/做多": "Możliwość short/long",
  设置止盈止损: "Ustaw take-profit/stop-loss",
  止盈价: "Cena take-profit",
  止损价: "Cena stop-loss",
  成本: "Cena kosztu",
  做多: "Long",
  做空: "Short",
  仓位信息: "Informacje o pozycji",
  一键平仓: "Zamknij pozycję (jeden klik)",
  永续: "Perpetual",
  浮动盈亏: "Niezrealizowany zysk/strata",
  平仓: "Zamknij pozycję",
  反向开仓: "Otwórz odwrotną pozycję",
  一键撤销: "Anuluj wszystko (jeden klik)",
  倍杠杆: "krotna dźwignia",
  执行价格: "Cena wykonania",
  委托数量: "Ilość zlecenia",
  保证金: "Depozyt zabezpieczający",
  成交价: "Cena wykonania",
  创建时间: "Czas utworzenia",
  撤销: "Anuluj",
  合约市场: "Rynek futures",
  交易方向: "Kierunek transakcji",
  委托价格: "Cena zlecenia",
  委托金额: "Kwota zlecenia",
  资金费率: "Stopa finansowania",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Okresowa opłata płacona przez pozycje długie i krótkie, rozliczana co 8 godzin.",
  "资金费率为正，多方向空方支付资金费用。":
    "Przy dodatniej stopie finansowania pozycje długie płacą krótkim.",
  "资金费率为负，空方向多方支付资金费用。":
    "Przy ujemnej stopie finansowania pozycje krótkie płacą długim.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Czy na pewno chcesz otworzyć odwrotną pozycję? Spowoduje to zakup przeciwnego kierunku do Twojej obecnej pozycji.",
  "仓位止盈/止损": "Take-profit/Stop-loss dla pozycji",
  合约名称: "Kontrakt futures",
  开仓价格: "Cena otwarcia",
  指数价格: "Cena indeksu",
  止盈设置: "Ustawienia take-profit",
  请输入止盈价: "Wprowadź cenę take-profit",
  "当指数价格触达*时，将会触发委托平仓":
    "Gdy cena indeksu osiągnie *, zostanie wywołane zlecenie zamknięcia.",
  预计盈亏: "Oczekiwany zysk/strata",
  当前仓位: "Bieżąca pozycja",
  平仓金额: "Kwota zamknięcia",
  仓位模式: "Tryb pozycji",
  全仓模式: "Tryb krzyżowego depozytu zabezpieczającego",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "W trybie krzyżowego depozytu zabezpieczającego wszystkie dostępne środki na Twoim koncie futures są używane jako depozyt zabezpieczający. Likwidacja następuje, gdy strata przekroczy całkowite saldo, co skutkuje utratą całego depozytu zabezpieczającego i pozycji.",
  逐仓模式: "Tryb izolowanego depozytu zabezpieczającego",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Określona kwota depozytu zabezpieczającego jest przypisana do pozycji. Jeśli strata depozytu spadnie poniżej poziomu depozytu utrzymania, pozycja jest likwidowana. W trybie izolowanym możesz zwiększać lub zmniejszać depozyt dla tej pozycji.",
  "是否撤销？": "Anulować zlecenie?",
  "是否一键撤销？": "Anulować wszystkie zlecenia?",
  "是否一键平仓？": "Zamknąć wszystkie pozycje?",
  持仓保证金: "Depozyt bieżącej pozycji",
  风险率: "Wskaźnik ryzyka",
  未实现盈亏: "Niezrealizowany zysk/strata",
  可用保证金: "Dostępny depozyt zabezpieczający",
  净值: "Wartość netto",
  账户余额: "Saldo konta",
  合约计算器: "Kalkulator futures",
  交易记录: "Historia transakcji",
  "*倍杠杆": "*krotna dźwignia",
  "平仓盈亏：": "Zrealizowany zysk/strata:",
  时间筛选: "Filtr czasu",
  仓位类型: "Typ pozycji",
  订单状态: "Status zamówienia",
  订单类型: "Typ zlecenia",
  平仓价格: "Cena zamknięcia",
  持仓数量: "Ilość pozycji",
  "手续费(%)": "Opłata transakcyjna (%)",
  平仓时间: "Czas zamknięcia",
  平仓类型: "Typ zamknięcia",
  手动平仓: "Ręczne zamknięcie",
  强制平仓: "Wymuszona likwidacja",
  近1天: "Ostatni dzień",
  近7天: "Ostatnie 7 dni",
  近30天: "Ostatnie 30 dni",
  近180天: "Ostatnie 180 dni",
  持仓: "Otwarta pozycja",
  已取消: "Anulowane",
  分时: "W ciągu dnia",
  "24H额(USDT)": "Wolumen 24h (USDT)",
  "24H低": "24h najniższy",
  "24H量(BTC)": "Wolumen 24h (BTC)",
  "24H高": "24h najwyższy",
  "10秒": "10 sekund",
  "30秒": "30 sekund",
  "1分": "1 minuta",
  "3分": "3 minuty",
  "5分": "5 minut",
  "30分": "30 minut",
  "1小时": "1 godzina",
  "4小时": "4 godziny",
  "8小时": "8 godzin",
  "1天": "1 dzień",
  "1周": "1 tydzień",
  "1月": "1 miesiąc",
  单向持仓: "Jednokierunkowa pozycja",
  杠杆: "Dźwignia",
  仓位: "Pozycja",
  计算结果: "Wynik",
  盈亏: "Zysk/Strata",
  收益率: "Zyskowność",
  计算结果仅供参考: "Wynik jest orientacyjny",
  成交后仓位大小: "Wielkość pozycji po wykonaniu",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Wynik jest orientacyjny, rzeczywiste wyniki mogą się różnić z powodu opłat.",
  目标价格: "Cena docelowa",
  开始计算: "Oblicz",
  强平价格: "Cena likwidacji",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Przed wpłatą dokładnie sprawdź nazwę łańcucha. Błędnych wpłat nie można cofnąć. Minimalna kwota wpłaty to *. Wpłaty poniżej tej kwoty nie zostaną przetworzone. Nie wysyłaj innych aktywów na ten adres. Nie używaj adresów ICO lub crowdfundingowych do wypłat.",
  "最小输入*": "Minimum {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Minimalna ilość wypłaty to *. Opłaty za wypłatę zostaną potrącone z kwoty wypłaty. Dokładnie sprawdź adres odbiorcy. Nie wysyłaj * na adresy spoza *. Nie używaj adresów ICO lub crowdfundingowych.",
  退出登录: "Wyloguj się",
  加仓: "Zwiększ pozycję",
  新增仓位: "Nowa pozycja",
  输入加仓金额: "Wprowadź kwotę zwiększenia pozycji",
  "当前可用:": "Obecnie dostępne:",
  资产账单: "Rachunek aktywów",
  保存二维码: "Zapisz kod QR",
  温馨提示: "Uwaga",
  "请注意：您当前使用的网络": "Uwaga: Obecnie używasz sieci",
  输入提现地址: "Wprowadź adres wypłaty",
  "可用金额：": "Dostępna kwota:",
  输入资产密码: "Wprowadź hasło aktywów",
  可用手续费: "Dostępna opłata",
  "折扣%": "Rabat %",
  实扣手续费: "Faktycznie naliczona opłata",
  实际到账: "Faktycznie otrzymana kwota",
  未设置资产密码: "Nie ustawiono hasła aktywów",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Dla Twojego bezpieczeństwa ustaw hasło aktywów przed dokonaniem wypłaty.",
  热榜: "Popularne",
  涨幅榜: "Największe wzrosty",
  跌幅榜: "Największe spadki",
  成交额榜: "Ranking wolumenu",
  关于我们: "O nas",
  登录密码: "Hasło logowania",
  设置: "Ustawienia",
  资产密码: "Hasło aktywów",
  修改登录密码: "Zmień hasło logowania",
  原密码: "Stare hasło",
  请输入新密码: "Wprowadź nowe hasło",
  请输入原密码: "Wprowadź stare hasło",
  确认密码: "Potwierdź hasło",
  确定修改: "Potwierdź zmianę",
  修改资产密码: "Zmień hasło aktywów",
  验证码: "Kod weryfikacyjny",
  资产密码使用提示: "Wskazówki dotyczące hasła aktywów",
  "资产密码用于转移、提取资产和交易。":
    "Hasło aktywów jest używane do przenoszenia, wypłacania i handlu aktywami.",
  "创建与登录密码不同的资产密码。":
    "Utwórz hasło aktywów inne niż hasło logowania.",
  "定期更改您的资产密码。": "Regularnie zmieniaj swoje hasło aktywów.",
  提币历史: "Historia wypłat",
  "金额/余额": "Kwota/Saldo",
  "手续费/折扣": "Opłata/Rabat",
  自选: "Ulubione",
  现货: "Spot",
  市价: "Cena rynkowa",
  止损设置: "Ustawienia stop-loss",
  合约K线图: "Wykres futures",
  "24H量": "Wolumen 24h",
  "24H额": "Wolumen 24h (USDT)",
  合作指南: "Przewodnik dla partnera",
  盈亏计算: "Obliczanie zysku/straty",
  当前可用: "Obecnie dostępne",
  请输入加仓金额: "Wprowadź kwotę zwiększenia pozycji",
  请重新输入加仓金额: "Wprowadź ponownie kwotę zwiększenia pozycji",
  平仓数量: "Ilość do zamknięcia",
  欢迎登录: "Witaj ponownie",
  "忘记密码?": "Zapomniałeś hasła?",
  "还没有账号？": "Nie masz jeszcze konta?",
  立即注册: "Zarejestruj się teraz",
  繁體中文: "Tradycyjny chiński",
  找回密码: "Odzyskaj hasło",
  下一步: "Dalej",
  注册账户: "Zarejestruj konto",
  "请输入邀请码(选填)": "Wprowadź kod zaproszenia (opcjonalnie)",
  谢邀豪礼: "Bonus za zaproszenie",
  "24小时邀请好友排名": "24-godzinny ranking zaproszeń",
  "*人": "* osób",
  "差*人": "Brakuje * osób",
  "已超过10万人，每月轻松赚钱":
    "Ponad 100 000 użytkowników, zarabiaj łatwo każdego miesiąca",
  最高: "Maksymalny",
  邀请链接: "Link zaproszenia",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Dziel się opłatami transakcyjnymi generowanymi przez Twoich znajomych (spot, futures, dźwignia, szybka wymiana).",
  平台和您一起分享手续费: "Dziel się opłatami transakcyjnymi z platformą",
  "*级": "* poziom",
  规则: "Zasady",
  我的好友: "Moi znajomi",
  好友详情: "Szczegóły znajomego",
  获得好友佣金方案: "Plan prowizji dla znajomych",
  我的等级: "Mój poziom",
  我的邀请数据: "Moje statystyki zaproszeń",
  当前等级: "Obecny poziom",
  平台奖励您: "Nagroda platformy dla Ciebie",
  最高可获取平台奖励: "Maksymalna nagroda platformy",
  邀请规则: "Zasady zapraszania",
  "邀请*级有效好友": "Zaproś aktywnych znajomych na poziomie *",
  好友等级: "Poziom znajomego",
  人: "osób",
  奖金派送: "Wypłata bonusu",
  平台奖励: "Nagroda platformy",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Platforma zastrzega sobie prawo do ostatecznej interpretacji. W przypadku oszukańczych działań nagrody zostaną cofnięte, a Twoje konto zamrożone. Utracone aktywa nie mogą zostać odzyskane.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Twoje konto musi być aktywne, zdefiniowane jako wpłata o wartości co najmniej * USDT w dowolnej kryptowalucie.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Zaproszony znajomy musi być aktywnym dolnym poziomem, zdefiniowanym jako wpłata o wartości co najmniej * USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Zapraszający i zaproszony nie mogą dzielić tego samego adresu IP.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "Poziom VIP jest określany przez liczbę zaproszonych znajomych na poziomie *.",
  佣金成分: "Składniki prowizji",
  收益统计: "Statystyki zysku",
  昨日收益: "Wczorajszy zysk",
  月收益: "Miesięczny zysk",
  获取收益: "Uzyskaj zysk",
  "总收益：": "Całkowity zysk:",
  "*级好友": "Znajomi na poziomie *",
  理财购买: "Kupno produktu finansowego",
  期限: "Okres",
  可用金额: "Dostępna kwota",
  预估收益: "Szacowany zysk",
  申购上限: "Maksymalny zakup",
  项目剩余: "Pozostało z projektu",
  "买入后预计*(SGT)开始计算收益。":
    "Zysk zacznie być naliczany około *(SGT) po zakupie.",
  计息日: "Początek naliczania odsetek",
  申购日: "Data zakupu",
  到账日: "Data uznania",
  到期自动续投: "Automatyczne reinwestowanie po wygaśnięciu",
  申购: "Kup",
  搜索理财项目: "Szukaj produktu finansowego",
  超高年化随心选: "Wybierz spośród produktów o wysokim zysku",
  "自由选择理财币种，稳定超额收益":
    "Dowolnie wybierz swoją kryptowalutę dla stabilnych, ponadprzeciętnych zysków",
  理财总资产: "Całkowite zainwestowane aktywa",
  申购数量: "Ilość do kupienia",
  立即购买: "Kup teraz",
  年化收益率: "Roczna stopa zwrotu (APY)",
  理财订单: "Zamówienia produktów finansowych",
  持有: "W posiadaniu",
  申购份额: "Kupiony udział",
  到账日期: "Data uznania",
  申购成功: "Zakup udany",
  到期: "Wygasło",
  是否选择做多: "Otworzyć pozycję long?",
  "可用余额为0 不能操作": "Saldo wynosi 0, działanie niemożliwe",
  福利中心: "Centrum bonusów",
  奖励记录: "Historia nagród",
  我获取到的奖励: "Moje zdobyte nagrody",
  总价值: "Całkowita wartość",
  新手任务: "Zadania dla nowych użytkowników",
  身份认证: "Weryfikacja tożsamości (KYC)",
  身份验证: "Weryfikacja tożsamości",
  去验证: "Zweryfikuj teraz",
  审核中: "Oczekuje",
  已验证: "Zweryfikowany",
  认证失败: "Weryfikacja nieudana",
  基础认证: "Podstawowa weryfikacja",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Uwaga: Zweryfikowanych informacji nie można zmienić. Wprowadź dokładne dane.",
  "国家/地区": "Kraj/Region",
  请选择: "Wybierz",
  证件类型: "Rodzaj dokumentu",
  证件编码: "Numer dokumentu",
  身份证: "Dowód osobisty",
  护照: "Pasaport",
  驾驶证: "Prawo jazdy",
  请输入编码: "Wprowadź numer",
  名字: "Imię",
  请输入: "Wprowadź",
  中间名: "Drugie imię",
  选填: "Opcjonalne",
  姓氏: "Nazwisko",
  中国: "Chiny",
  身份上传: "Prześlij dokument tożsamości",
  上传身份证: "Prześlij dowód osobisty",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Prześlij w formacie JPG/JPEG/PNG. Upewnij się, że zdjęcia są wyraźne, kompletne i równomiernie oświetlone. Maksymalnie *MB.",
  确定提交: "Wyślij",
  去认证: "Zweryfikuj",
  挑战任务: "Zadania wyzwania",
  注册认证任务: "Zadanie rejestracji i weryfikacji",
  完成注册认证即可领取: "Ukończ rejestrację i weryfikację, aby otrzymać",
  领取奖励: "Odbierz nagrodę",
  新人豪礼: "Bonus powitalny",
  "参与人数：": "Liczba uczestników:",
  条件: "Warunek",
  入金量: "Kwota wpłaty",
  完成: "Ukończone",
  任务奖励: "Nagroda za zadanie",
  距任务更新: "Do aktualizacji zadania",
  "条件：": "Warunek:",
  活动规则: "Zasady aktywności",
  奖励明细: "Szczegóły nagrody",
  已获得: "Zdobyto",
  交易奖励: "Nagroda za handel",
  Win奖励: "Nagroda WIN",
  已领取: "Odebrano",
  亏损金额超过: "Kwota straty przekracza",
  单笔开仓金额超过: "Kwota pojedynczego zlecenia przekracza",
  交易量: "Wolumen transakcji",
  待完成: "Oczekujące",
  入金: "Wpłata",
  盈利金额超过: "Kwota zysku przekracza",
  开仓金额: "Kwota zlecenia",
  开仓金: "Kwota zlecenia",
  盈利: "Zysk",
  亏损: "Strata",
  领取: "Odbierz",
  未领取: "Nie odebrano",
  待领取: "Do odebrania",
  再交易: "Handluj dalej",
  即可获得: "aby otrzymać",
  领取成功: "Odebrano pomyślnie",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Wszystkie aktywności zostaną rozliczone na datę zakończenia. Nagrody wygasną po tym terminie.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Zdobyty zysk zostanie zaksięgowany na Twoim koncie nagród, które możesz wymienić lub wypłacić w dowolnym momencie.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Kryptowaluta nagrody zależy od zadania.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Platforma zastrzega sobie prawo do ostatecznej interpretacji. W przypadku oszustwa w zadaniach nagrody zostaną wstrzymane, a Twoje konto może zostać zamrożone.",
  成长学院: "Akademia",
  "区块链 & 加密货币": "Blockchain & Kryptowaluty",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Twój kompletny przewodnik po kryptowalutach. Towarzyszymy Ci w Twojej kryptopodróży.",
  "全仓合约定单的全部保证金。":
    "Całkowity depozyt zabezpieczający dla zleceń futures z krzyżowym depozytem zabezpieczającym.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Saldo + (niezrealizowany zysk/strata - opłaty - odsetki finansowania) = Wartość netto / Wykorzystany depozyt * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Niezrealizowany zysk/strata bezpośrednio wpływa na 'dostępny depozyt zabezpieczający'. Jeśli niezrealizowany zysk/strata rośnie, dostępny depozyt rośnie i odwrotnie.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Saldo - (Wykorzystany depozyt) + (niezrealizowany zysk/strata - opłaty - odsetki finansowania)",
  "注:可继续用于开仓的保证金。":
    "Uwaga: Depozyt dostępny do otwierania nowych pozycji.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Saldo + (niezrealizowany zysk/strata - opłaty - odsetki finansowania)",
  "注:当前的资金结余。": "Uwaga: Bieżące saldo.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Odnosi się do całkowitego salda konta futures, w tym zamrożonych kwot.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Uwaga: Im wyższy wskaźnik ryzyka, tym niższe ryzyko i odwrotnie.",
  该功能尚未开发: "Ta funkcja jest jeszcze w fazie rozwoju",
  重置密码: "Zresetuj hasło",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Wprowadź 8-20 znaków, w tym litery, cyfry i znaki specjalne",
  修改成功: "Zmiana udana",
  输入验证码: "Wprowadź kod weryfikacyjny",
  输入密码: "Wprowadź hasło",
  详情说明: "Szczegóły",
  已售罄: "Wyprzedane",
  剩余期限: "Pozostały okres",
  限期: "Okres",
  闪兑货币选择: "Wybór waluty do szybkiej wymiany",
  地区选择: "Wybór regionu",
  "搜索国家/地区": "Szukaj kraju/regionu",
  "身份信息已提交，将在*小时内审核完成":
    "Informacje o tożsamości zostały wysłane. Przetwarzanie potrwa do * godzin.",
  "选择国家/地区": "Wybierz kraj/region",
  "止盈价格需高于*": "Cena take-profit musi być wyższa niż *",
  "止损价格需低于*": "Cena stop-loss musi być niższa niż *",
  "止盈价格需低于*": "Cena take-profit musi być niższa niż *",
  "止损价格需高于*": "Cena stop-loss musi być wyższa niż *",
  教程详情: "Szczegóły samouczka",
  请输入止损价: "Wprowadź cenę stop-loss",
  活期: "Elastyczny",
  赎回后立即到账: "Natychmiastowe uznanie po wykupie",
  赎回: "Wykup",
  赎回理财: "Wykup produkt finansowy",
  是否赎回当前的理财订单: "Wykupić bieżące zamówienie produktu finansowego?",
  维护: "Konserwacja",
  "系统正在维护中……": "System jest w trakcie konserwacji...",
  合约: "Kontrakty futures",
  闪电兑换: "Szybka wymiana",
  流水挖矿: "Wydobywanie wolumenu",
  邀请豪礼: "Bonus za zaproszenie",
  计算器: "Kalkulator",
  最新价: "Ostatnia cena",
  涨跌幅: "Zmiana (24h)",
  关注币种添加自选: "Dodaj kryptowalutę do ulubionych",
  一键添加自选: "Dodaj do ulubionych (jeden klik)",
  全标已读: "Oznacz wszystkie jako przeczytane",
  无消息: "Brak wiadomości",
  "暂时还没有收到任何消息通知哦!":
    "Nie otrzymałeś jeszcze żadnych powiadomień!",
  没有更多数据: "Brak dalszych danych",
  闪兑: "Szybka wymiana",
  从: "Z",
  "可用余额：": "Dostępne saldo:",
  至: "Do",
  预览兑换结果: "Podgląd wyniku wymiany",
  闪兑规则: "Zasady szybkiej wymiany",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Szybka wymiana podlega wahaniom rynkowym. Rzeczywiście otrzymana kwota jest wiążąca.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Kursy wymiany są ustalane przez strony trzecie. Ze względu na koszty i wahania kurs może odbiegać od kursu rynkowego. Sprawdź dokładnie.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Platforma pobiera około *% opłaty za wymianę, aby pokryć koszty na giełdach.",
  确认汇兑: "Potwierdź wymianę",
  您预估得到: "Szacowany odbiór",
  汇兑: "Wymiana",
  汇兑比例: "Kurs wymiany",
  刷新: "Odśwież",
  兑换: "Wymień",
  没有更多了: "Brak dalszych danych",
  搜索币种: "Szukaj kryptowaluty",
  可用: "Dostępny",
  我知道了: "Rozumiem",
  最新价格: "Ostatnia cena",
  确认: "Potwierdź",
  最大: "Maksymalny",
  "风险率(%)": "Wskaźnik ryzyka (%)",
  当前委托: "Bieżące zlecenia",
  合作交易历史记录: "Historia transakcji partnera",
  重置: "Resetuj",
  余额: "Saldo",
  现货账户: "Konto spot",
  合约账户: "Konto futures",
  WIN账户: "Konto WIN",
  赏金账户: "Konto nagród",
  总资产折合: "Aktywa ogółem (w USDT)",
  今日收益: "Dzisiejszy zysk",
  充币: "Wpłata",
  提币: "Wypłata",
  账户权益: "Wartość konta",
  "数量/类别": "Ilość/Kategoria",
  全部币种: "Wszystkie kryptowaluty",
  全部类型: "Wszystkie typy",
  账单信息: "Informacje o rachunku",
  理财赎回: "Wykup produktu finansowego",
  购买理财: "Zakup produktu finansowego",
  收入: "Przychody",
  支出: "Wydatki",
  到: "do",
  资产划转: "Przeniesienie aktywów",
  "最少*": "Minimum *",
  "可用资产：": "Dostępne aktywa:",
  确认划转: "Potwierdź przeniesienie",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Musisz przenieść aktywa na odpowiednie konto, aby móc handlować. Przenoszenie między kontami jest bezpłatne.",
  币种账户选择: "Wybór konta kryptowaluty",
  选择账户: "Wybierz konto",
  划转详情: "Szczegóły przeniesienia",
  划转明细: "Specyfikacja przeniesienia",
  收入账单: "Rachunek przychodów",
  支出账单: "Rachunek wydatków",
  金额: "Kwota",
  总收益: "Całkowity zysk",
  佣金: "Prowizja",
  用户名: "Nazwa użytkownika",
  "已领取：": "Odebrano:",
  "未领取：": "Nie odebrano:",
  "请选择国家/地区": "Wybierz kraj/region",
  请上传身份信息: "Prześlij informacje o tożsamości",
  请选择证件类型: "Wybierz typ dokumentu",
  请填写证件编码: "Wprowadź numer dokumentu",
  请填写名字: "Wprowadź imię",
  请填写姓氏: "Wprowadź nazwisko",
  投资金额: "Kwota inwestycji",
  天: "dni",
  请输入手机号: "Wprowadź numer telefonu",
  搜索: "Szukaj",
  搜索历史: "Historia wyszukiwania",
  热门推荐: "Popularne rekomendacje",
  "《Xspace Earn协议》": "Protokół Xspace Earn",
  我已了解并同意: "Rozumiem i akceptuję",
  协议: "Protokół",
  Xspace官方中文交流群: "Oficjalna chińska społeczność Xspace",
  Xspace官方英文交流群: "Oficjalna angielska społeczność Xspace",
  预计维护至: "Przewidywane zakończenie konserwacji",
  更多功能: "Więcej funkcji",
  下载APP: "Pobierz aplikację",
  理财: "Produkt finansowy",
  推荐: "Polecane",
  Telegram官方中文频道: "Oficjalny kanał Telegram (chiński)",
  Telegram官方英文频道: "Oficjalny kanał Telegram (angielski)",
  官方邮箱: "Oficjalny adres e-mail",
  客服邮箱: "Adres e-mail obsługi klienta",
  上述信息最终解释权归官方所有:
    "Powyższe informacje podlegają oficjalnej interpretacji platformy.",
  IOS版下载: "Pobierz dla iOS",
  Android版下载: "Pobierz dla Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Opłata transakcyjna = Opłata kupna + Stopa finansowania + Opłata sprzedaży",
  资金划转: "Przeniesienie środków",
  止盈: "Take-profit",
  止损: "Stop-loss",
  自动平仓: "Automatyczne zamknięcie",
  委托挂单: "Otwarte zlecenie",
  买: "Kup",
  卖: "Sprzedaj",
  "买入/做多": "Kup/Long",
  "卖出/做空": "Sprzedaj/Short",
  详情: "Szczegóły",
  浮动涨跌: "Niezrealizowany zysk/strata",
  最小: "Minimalny",
  充币数量: "Ilość wpłaty",
  请输入充币数量: "Wprowadź ilość wpłaty",
  支付截图: "Dowód płatności",
  提交: "Wyślij",
  上传驾驶证: "Prześlij prawo jazdy",
  上传护照: "Prześlij paszport",
  加载中: "Ładowanie...",
  上传成功: "Przesyłanie udane",
  充值历史: "Historia wpłat",
  合约卖出手续费: "Opłata za sprzedaż futures",
  合约买入手续费: "Opłata za zakup futures",
  系统加款: "Zaksięgowanie systemowe",
  系统减款: "Obciążenie systemowe",
  合约资金费率: "Stopa finansowania futures",
  佣金分成: "Podział prowizji",
  U本位合约: "Kontrakty futures z depozytem w USDT",
  资产管理: "Zarządzanie aktywami",
  APP下载: "Pobierz aplikację",
  全球领先的数字理财平台:
    "Wiodąca na świecie platforma cyfrowego zarządzania majątkiem",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Handluj natychmiast Bitcoinem, Ethereum i setkami innych aktywów cyfrowych",
  "24H涨跌幅": "Zmiana 24h",
  查看更多行情: "Zobacz więcej rynków",
  近24小时成交量: "Wolumen 24h",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Oferuje setki par spot i futures. Ponad 20 milionów użytkowników w ponad 200 krajach. Wiodąca na świecie platforma usług dla aktywów cyfrowych.",
  用户国家分布: "Użytkownicy według krajów",
  用户数: "Liczba użytkowników",
  交易对: "Pary transakcyjne",
  服务支持: "Wsparcie",
  "随时随地，多平台终端交易": "Handluj wszędzie dzięki wsparciu wielu platform",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Kompatybilny z wieloma urządzeniami dla wszystkich potrzeb transakcyjnych.",
  随时查看实时行情: "Zobacz ceny w czasie rzeczywistym gdziekolwiek jesteś",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Łatwo kupuj i sprzedawaj BTC, ETH, DOGE i inne aktywa cyfrowe",
  获取您关注的加密货币价格变化预警:
    "Otrzymuj alerty cenowe dla obserwowanych kryptowalut",
  "查看比特币现货、期货、期权价格":
    "Zobacz ceny spot, futures i opcji na Bitcoin",
  比较各交易所加密货币价格: "Porównaj ceny kryptowalut na różnych giełdach",
  开启您的数字货币之旅: "Rozpocznij swoją podróż z aktywami cyfrowymi",
  快捷购买数字货币: "Szybko kupuj kryptowaluty",
  "使用多种支付方式交易数字货币，安全快捷":
    "Handluj bezpiecznie i szybko za pomocą wielu metod płatności",
  最优的交易费率: "Najlepsze opłaty transakcyjne",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Korzystne stawki, konkurencyjne przywileje VIP i usługi najwyższej jakości.",
  可信赖的安全保障: "Niezawodne bezpieczeństwo",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Zaawansowane środki bezpieczeństwa i fundusz SAFU chronią Twoje aktywa przed ryzykiem.",
  交易: "Handel",
  币币市场: "Rynek spot",
  "24H成交量": "Wolumen 24h",
  交易所: "Giełda",
  "24H最高": "24h najwyższy",
  "24H最低": "24h najniższy",
  永续合约: "Kontrakty perpetual",
  日涨跌: "Dzienna zmiana",
  交易深度: "Głębokość księgi zleceń",
  "资产(合约)": "Aktywa (Futures)",
  历史仓位: "Historia pozycji",
  兑换记录: "Historia wymian",
  类型: "Typ",
  充值记录: "Historia wpłat",
  划转记录: "Historia przeniesień",
  类别: "Kategoria",
  历史账单: "Historia rachunków",
  在线充值: "Wpłata online",
  安全设置: "Ustawienia bezpieczeństwa",
  用于账户登录使用: "Używane do logowania na konto",
  用户提现时安全验证使用:
    "Używane do weryfikacji bezpieczeństwa przy wypłatach",
  验证: "Zweryfikuj",
  万: "milion",
  随时随地开启交易: "Rozpocznij handel gdziekolwiek jesteś",
  "*货币交易所的所有功能尽在你的手中。":
    "Wszystkie funkcje giełdy * w Twoich rękach.",
  "下载*货币交易所APP。": "Pobierz aplikację giełdy *.",
  下载自: "Pobierz z",
  内测版: "Wersja beta",
  下载: "Pobierz",
  扫码下载: "Zeskanuj, aby pobrać",
  设置您的资产密码: "Ustaw swoje hasło aktywów",
  法币: "Waluta fiducjarna",
  我要买: "Chcę kupić",
  我要卖: "Chcę sprzedać",
  请输入金额: "Wprowadź kwotę",
  汇率: "Kurs wymiany",
  获得: "Otrzymaj",
  支付通道: "Kanał płatności",
  收款通道: "Kanał odbioru",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Upewnij się, że kanał odbioru jest na Twoje nazwisko podczas sprzedaży.",
  当前法币暂不支持交易对可尝试前往提现:
    "Ta para walut fiducjarnych nie jest obecnie obsługiwana. Spróbuj wypłaty.",
  前往提现: "Przejdź do wypłaty",
  该法币暂无通道: "Brak dostępnego kanału dla tej waluty fiducjarnej",
  "正在出售中，请耐心等待": "Sprzedaż w toku, proszę czekać",
  请选择支付通道: "Wybierz kanał płatności",
  请选择方式: "Wybierz metodę",
  法币历史: "Historia walut fiducjarnych",
  买币: "Kup kryptowalutę",
  卖币: "Sprzedaj kryptowalutę",
  失败: "Nieudane",
  已完成: "Zakończone",
  未付款: "Nieopłacone",
  待审核: "Oczekujące",
  打款中: "Płatność w toku",
  订单详情: "Szczegóły zamówienia",
  联系客服: "Skontaktuj się z obsługą klienta",
  到账金额: "Otrzymana kwota",
  通道: "Kanał",
  收款人: "Odbiorca",
  收款账户: "Konto odbiorcy",
  "订单出售失败，请查下方失败原因":
    "Sprzedaż zamówienia nieudana. Zobacz przyczynę poniżej.",
  失败原因: "Przyczyny niepowodzenia",
  您还未进行付款: "Nie dokonałeś jeszcze płatności",
  您已成功购买: "Zakup udany",
  已取消订单: "Zamówienie anulowane",
  "订单正在审核中，请耐心等待": "Zamówienie jest przetwarzane. Proszę czekać.",
  您已成功出售: "Sprzedaż udana",
  "订单正在打款中，请耐心等待": "Płatność w toku. Proszę czekać.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Aby dokonać płatności, musisz odwiedzić inną platformę. Zwróć uwagę na bezpieczeństwo swoich informacji.",
  当前法币暂不支持交易对可尝试前往充值:
    "Ta para walut fiducjarnych nie jest obecnie obsługiwana. Spróbuj wpłaty.",
  前往充值: "Przejdź do wpłaty",
  购买: "Kup",
  订单号: "Numer zamówienia",
  单价: "Cena jednostkowa",
  到账数量: "Otrzymana ilość",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Istnieje nieopłacone zamówienie. Czy chcesz rozpocząć nowe zlecenie płatności?",
  继续支付: "Kontynuuj płatność",
  重新下单: "Nowe zamówienie",
  是否确定出售: "Czy na pewno chcesz sprzedać?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Po potwierdzeniu platforma przydzieli kupującego. Poczekaj na dopasowanie.",
  出售: "Sprzedaj",
  收款方式: "Metoda odbioru",
  订单已生成: "Zamówienie wygenerowane",
  取消订单: "Anuluj zamówienie",
  请在: "Proszę w ciągu",
  内完成付款: "dokonać płatności",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Opuść platformę, zaloguj się do wybranej metody płatności i przelej kwotę na następujące konto sprzedającego. Zawsze podawaj referencję:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Bez referencji sprzedający nie będzie mógł potwierdzić płatności, co może prowadzić do utraty aktywów.",
  "未在规定的时间内付款，订单都将被取消。":
    "Jeśli nie dokonasz płatności w określonym czasie, zamówienie zostanie anulowane.",
  姓名: "Imię i nazwisko",
  收款姓名: "Imię i nazwisko odbiorcy",
  开户支行: "Oddział banku",
  银行卡号: "Numer karty bankowej",
  "付款后，返回本平台": "Po dokonaniu płatności wróć na tę platformę",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Kliknij przycisk 'Dokonałem płatności, powiadom sprzedającego'",
  未点击卖家不会放款:
    "Sprzedający zwolni kryptowalutę dopiero po kliknięciu przycisku",
  交易条款: "Warunki transakcji",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Środki na zakup muszą być legalne i bezpieczne",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Oszustwa, piramidy, hazard lub inne nielegalne środki nie są dozwolone",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Jeśli po transakcji środki zostaną zamrożone lub będą podejrzane, nie zwolnimy USDT i dokonamy zwrotu",
  "已付款，通知卖家": "Zapłacono, powiadom sprzedającego",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Jeśli anulujesz łącznie * zamówień dzisiaj, Twoje prawo do zakupu na dziś zostanie cofnięte. Anulować to zamówienie?",
  添加收款方式: "Dodaj metodę odbioru",
  是否删除此收款方式: "Usunąć tę metodę odbioru?",
  删除: "Usuń",
  请选择法币: "Wybierz walutę fiducjarną",
  机构名称: "Nazwa instytucji",
  请选择机构: "Wybierz instytucję",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Wybrana metoda odbioru będzie widoczna dla kupujących, gdy sprzedajesz kryptowalutę. Upewnij się, że dane są prawidłowe.",
  请选择银行: "Wybierz bank",
  请输入姓名: "Wprowadź imię i nazwisko",
  账号: "Numer konta",
  请输入账号: "Wprowadź numer konta",
  收款码: "Kod odbioru",
  "银行账号/卡号": "Numer konta bankowego / Numer karty",
  "请输入银行账号/卡号": "Wprowadź numer konta bankowego / numer karty",
  "开户支行（选填）": "Oddział banku (opcjonalnie)",
  请输入开户支行: "Wprowadź oddział banku",
  "加入*官方频道": "Dołącz do oficjalnego kanału *",
  关于: "O nas",
  条款: "Warunki",
  成功: "Sukces",
  等待: "Oczekiwanie",
  作废: "Nieważne",
  确认付款: "Potwierdź płatność",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Płatność zakończona? Po potwierdzeniu sprzedający potwierdzi otrzymanie w ciągu * minut.",
  最大金额: "Maksymalna kwota",
  最小金额: "Minimalna kwota",
  付款: "Zapłać",
  法币充值: "Wpłata waluty fiducjarnej",
  法币提现: "Wypłata waluty fiducjarnej",
  待支付: "Do zapłaty",
  已支付: "Zapłacone",
  商户名: "Nazwa sprzedającego",
  当前没有添加支付方式: "Nie dodano metody płatności",
  添加后再出售: "Dodaj jedną przed sprzedażą",
  新人大礼包: "Pakiet powitalny",
  注册即可领取: "Odbierz po rejestracji",
  立即领取: "Odbierz teraz",
  不再提示: "Nie pokazuj ponownie",
  "该奖励需在APP中领取，请下载APP":
    "Tę nagrodę można odebrać tylko w aplikacji. Pobierz aplikację.",
  去交易: "Przejdź do handlu",
  期权交易: "Handel opcjami",
  交易额: "Kwota transakcji",
  可用额度: "Dostępny limit",
  交易周期: "Okres transakcji",
  看涨: "Wzrost (Call)",
  看跌: "Spadek (Put)",
  看空: "Short",
  当前持有: "Bieżąca pozycja",
  胜率: "Wskaźnik wygranych",
  "盈利/亏损数": "Liczba transakcji z zyskiem/stratą",
  累计实现盈亏: "Zrealizowany całkowity zysk/strata",
  秒: "sekund",
  分: "minut",
  小时: "godzin",
  周: "tydzień",
  下单时间: "Czas zamówienia",
  剩余时间: "Pozostały czas",
  买入价: "Cena zakupu",
  结算价: "Cena rozliczenia",
  实现盈利: "Zrealizowany zysk",
  结算时间: "Czas rozliczenia",
  期权: "Opcja",
  新手教程: "Samouczek dla początkujących",
  我的订单: "Moje zamówienia",
  赔率: "Kurs",
  全部订单: "Wszystkie zamówienia",
  持有订单: "Otwarte zamówienia",
  历史订单: "Historia zamówień",
  输入交易额度: "Wprowadź kwotę transakcji",
  选择交易周期: "Wybierz okres transakcji",
  去注册: "Zarejestruj się",
  冻结: "Zamroź",
  期权支出: "Wydatek opcji",
  期权收入: "Przychód z opcji",
  用户提现: "Wypłata użytkownika",
  "是否购买？": "Kupić tę opcję?",
  购买成功: "Zakup udany",
  请签名: "Proszę podpisać",
  提交签名: "Wyślij podpis",
  清空签名: "Wyczyść podpis",
  签名审核中: "Podpis w trakcie weryfikacji",
  已提交: "Wysłano",
  扫一扫下载APP: "Zeskanuj, aby pobrać aplikację",
  新手领取大礼包: "Pakiet powitalny dla nowych użytkowników",
  注册实名即送彩金: "Zarejestruj się i zweryfikuj, aby otrzymać bonus",
  交易总额: "Całkowity wolumen transakcji",
  资产不足: "Niewystarczające aktywa",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Niewystarczające aktywa na koncie WIN. Możesz przenieść aktywa ze swojego głównego konta.",
  Win: "WIN",
  比赛: "Zawody",
  未开始: "Nie rozpoczęte",
  赛程: "Harmonogram",
  赛果: "Wynik",
  已结束: "Zakończone",
  让球: "Handicap",
  进球数: "Bramki",
  大: "Ponad",
  小: "Poniżej",
  胜负平: "1X2 (Zwycięstwo/Remis/Porażka)",
  和局: "Remis",
  投注: "Zakład",
  下注金额: "Kwota zakładu",
  下注: "Postaw",
  阵容: "Skład",
  分析: "Analiza",
  输入下注金额: "Wprowadź kwotę zakładu",
  下注成功: "Zakład postawiony",
  投注记录: "Historia zakładów",
  未结算: "Nierozliczone",
  已结算: "Rozliczone",
  流水: "Obrót",
  输赢: "Zysk/Strata",
  赛时: "Czas meczu",
  下注时间: "Czas zakładu",
  足彩竞猜: "Zakłady piłkarskie",
  查看详情: "Zobacz szczegóły",
  输: "Przegrana",
  赢: "Wygrana",
  主: "Gospodarz",
  客: "Gość",
  主胜: "Zwycięstwo gospodarzy",
  客胜: "Zwycięstwo gości",
  平: "Remis",
  已延期: "Przełożone",
  账号异常: "Nieprawidłowość konta",
  全场独赢: "Pełny czas 1X2",
  全场让球: "Pełny czas Handicap",
  全场大小: "Pełny czas Ponad/Poniżej",
  总进球: "Łączna liczba bramek",
  拍摄照片要求: "Wymagania dotyczące zdjęcia",
  标准拍摄: "Standardowe zdjęcie",
  边框缺失: "Brakująca ramka",
  照片模糊: "Nieostre zdjęcie",
  闪光强烈: "Zbyt silny błysk",
  上传手持证件照: "Prześlij zdjęcie z dokumentem w ręku",
  上传证件照: "Prześlij zdjęcie dokumentu",
  换一张: "Nowe zdjęcie",
  出生日期: "Data urodzenia",
  请选择出生日期: "Wybierz datę urodzenia",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Wprowadź poniższy kod weryfikacyjny, aby uzyskać kod e-mail do rejestracji.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Pozostało Ci * prób weryfikacji. Po przekroczeniu tego limitu nie będziesz mógł się zweryfikować.",
  上半场: "1. połowa",
  下半场: "2. połowa",
  独赢: "1X2",
  上半场独赢: "1. połowa 1X2",
  下半场独赢: "2. połowa 1X2",
  上半场让球: "1. połowa Handicap",
  下半场让球: "2. połowa Handicap",
  上半场大小球: "1. połowa Ponad/Poniżej",
  下半场大小球: "2. połowa Ponad/Poniżej",
  波胆: "Dokładny wynik",
  上半场波胆: "1. połowa Dokładny wynik",
  下半场波胆: "2. połowa Dokładny wynik",
  单双: "Nieparzysty/Parzysty",
  单: "Nieparzysty",
  双: "Parzysty",
  上半场单双: "1. połowa Nieparzysty/Parzysty",
  下半场单双: "2. połowa Nieparzysty/Parzysty",
  上半场总进球: "1. połowa Łączna liczba bramek",
  下半场总进球: "2. połowa Łączna liczba bramek",
  中场: "Przerwa",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Uwaga: W przypadku zdjęcia z dokumentem w ręku napisz tekst na białej kartce papieru i zrób zdjęcie razem z dokumentem, jak na przykładzie.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Ostatnio wiele oszukańczych kont zostało ukaranych. Skontaktuj się z obsługą klienta, jeśli uważasz, że Twoje konto zostało niesłusznie ukarane.",
  最小下注金额: "Minimalny zakład",
  参与活动最小下注金额: "Minimalny zakład, aby wziąć udział w aktywności",
  记住密码: "Zapamiętaj hasło",
  比分: "Wynik",
  "您还未登录，请先登录": "Nie jesteś zalogowany. Zaloguj się najpierw.",
  立即登录: "Zaloguj się teraz",
  下注限额: "Limit zakładu",
  可赢金额: "Kwota do wygrania",
  闪兑详情: "Szczegóły szybkiej wymiany",
  大小球: "Ponad/Poniżej",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Z powodu wahań kursów walut ostateczna kwota zakładu może się różnić. Zamówienie jest wiążące.",
  开赛时间: "Czas rozpoczęcia",
  足球收入: "Przychody z piłki nożnej",
  足球支出: "Wydatki na piłkę nożną",
  活动详情: "Szczegóły aktywności",
  为世界杯喝彩: "Wspieraj Mistrzostwa Świata",
  我的竞猜: "Moje typy",
  "竞猜比赛、有机会瓜分*USDT": "Typuj mecze i wygraj część z * USDT",
  "瓜分*USDT": "Podziel się * USDT",
  距离活动结束还有: "Do końca aktywności pozostało:",
  我的门票: "Moje bilety",
  竞猜结束时间: "Koniec typowania",
  猜比分: "Typuj wynik",
  "福利派送中，完成任务即可获取门票":
    "Bonusy są rozdawane. Wykonaj zadania, aby zdobyć bilety.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Wykonaj następujące zadania, aby uzyskać odpowiednią liczbę biletów do udziału w konkursie.",
  时: "godzina",
  活动: "Aktywność",
  竞猜记录: "Historia typów",
  结果: "Wynik",
  任务: "Zadanie",
  去邀请: "Zaproś",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Typuj wynik każdego meczu i wygraj część z $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Do typowania potrzebny jest bilet. Bilety można zdobyć, wykonując zadania platformy.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Po udanym typowaniu wyślij zrzut ekranu do obsługi klienta. Przekażą oni bonus na Twoje konto, które możesz natychmiast wypłacić.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Oszustwo jest zabronione. Jeśli zostanie wykryte, nagroda zostanie unieważniona.",
  "完成任务后，点击咨询客服获得门票。":
    "Po wykonaniu zadań kliknij 'Skontaktuj się z obsługą klienta', aby otrzymać bilety.",
  继续猜: "Kontynuuj typowanie",
  总单数: "Łączna liczba zakładów",
  赛事筛选: "Filtruj według wydarzenia",
  球队筛选: "Filtruj według drużyny",
  总金额: "Łączna kwota",
  总流水: "Łączny obrót",
  派奖金额: "Kwota wypłaconego bonusu",
  下注单数: "Liczba zakładów",
  利润: "Zysk",
  更多福利: "Więcej bonusów",
  我的奖金: "Mój bonus",
  未认证: "Niezweryfikowany",
  总量: "Razem",
  或: "lub",
  模拟交易: "Handel demo",
  体验账户不可操作: "Niedostępne na koncie demonstracyjnym",
  世界杯比分竞猜: "Typowanie wyników MŚ",
  "领*USDT起": "Odbierz od * USDT",
  消息: "Wiadomości",
  滚球: "Zakłady na żywo",
  是: "Tak",
  不是: "Nie",
  当前余额: "Bieżące saldo",
  KOL招募: "Rekrutacja KOL",
  本月净输赢: "Netto zysk/strata w tym miesiącu",
  本月佣金: "Prowizja w tym miesiącu",
  佣金比例: "Procent prowizji",
  活跃人数: "Aktywni użytkownicy",
  新增下级: "Nowi niższe poziomy",
  登录人数: "Zalogowani użytkownicy",
  首存人数: "Użytkownicy z pierwszą wpłatą",
  数据分析: "Analiza danych",
  人数: "Liczba osób",
  新注册存款金额: "Kwota wpłat nowych rejestracji",
  老用户存款金额: "Kwota wpłat istniejących użytkowników",
  首存金额: "Kwota pierwszej wpłaty",
  快捷入口: "Szybki dostęp",
  成员管理: "Zarządzanie członkami",
  财务报表: "Sprawozdania finansowe",
  分红报表: "Raport dywidendy",
  订单记录: "Historia zamówień",
  VIP专享: "Ekskluzywne VIP",
  推广工具: "Narzędzia promocyjne",
  计算规则: "Zasady obliczania",
  账变明细: "Szczegóły transakcji",
  成员: "Członkowie",
  下级概览: "Przegląd niższych poziomów",
  下级成员总计: "Razem niższe poziomy",
  本月新增: "Nowi w tym miesiącu",
  本月活跃会员: "Aktywni członkowie w tym miesiącu",
  今日活跃会员: "Aktywni członkowie dzisiaj",
  本月有效活跃: "Efektywnie aktywni w tym miesiącu",
  活跃成员占比: "Odsetek aktywnych członków",
  本月活跃: "Aktywni w tym miesiącu",
  今日活跃: "Aktywni dzisiaj",
  下级成员: "Niższe poziomy",
  会员账号: "Konto członka",
  统计时间: "Czas statystyki",
  筛选: "Filtruj",
  存款: "Wpłata",
  取款: "Wypłata",
  总输赢: "Całkowity zysk/strata",
  是否有效用户: "Aktywny użytkownik?",
  最近登录时间: "Ostatnie logowanie",
  否: "Nie",
  开始时间: "Czas rozpoczęcia",
  结束时间: "Czas zakończenia",
  提取: "Wypłać",
  总盈亏: "Całkowity wynik",
  净盈亏: "Wynik netto",
  分红: "Dywidenda",
  概览: "Przegląd",
  月度详细数据: "Miesięczne szczegółowe dane",
  未发放: "Niewypłacone",
  活跃用户: "Aktywni użytkownicy",
  有效新增会员: "Efektywni nowi członkowie",
  冲正后净输赢: "Netto zysk/strata po korekcie",
  上月结余: "Saldo z poprzedniego miesiąca",
  净输赢: "Netto zysk/strata",
  "系统每日新加坡时间1:00更新一次报表":
    "Raporty są aktualizowane codziennie o 01:00 czasu singapurskiego.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "W raportach dodatnie liczby oznaczają zysk dla partnera, ujemne liczby oznaczają stratę dla partnera.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Dane prowizji są aktualizowane codziennie, mają charakter orientacyjny i nie stanowią ostatecznej podstawy wypłaty.",
  选择时间: "Wybierz czas",
  足球: "Piłka nożna",
  投注金额: "Kwota zakładu",
  有效订单: "Ważne zamówienia",
  下级账户: "Konto niższego poziomu",
  待成交: "Oczekujące",
  下单金额: "Kwota zamówienia",
  订单内容: "Treść zamówienia",
  秒数: "Sekundy",
  联赛: "Liga",
  队伍: "Drużyna",
  比赛时间: "Czas meczu",
  玩法: "Rodzaj zakładu",
  等级规则表: "Tabela zasad poziomów",
  等级: "Poziom",
  活跃会员: "Aktywni członkowie",
  最新活跃: "Najnowsza aktywność",
  额外佣金: "Dodatkowa prowizja",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Miesięcznie w oparciu o standardy wzrostu. Możesz korzystać tylko z jednego poziomu.",
  渠道生成: "Generuj kanał",
  创建: "Utwórz",
  渠道名称: "Nazwa kanału",
  注册人数: "Liczba rejestracji",
  浏览人数: "Liczba wyświetleń",
  构建状态: "Status budowy",
  禁用: "Wyłącz",
  启用: "Włącz",
  查看: "Zobacz",
  创建渠道: "Utwórz kanał",
  创建成功: "Utworzono pomyślnie",
  操作成功: "Operacja zakończona sukcesem",
  渠道详情: "Szczegóły kanału",
  邀请码: "Kod zaproszenia",
  访问人数: "Liczba odwiedzających",
  渠道地址: "Adres kanału",
  我的福利: "Moje bonusy",
  充值福利: "Bonus za wpłatę",
  当前流水: "Bieżący obrót",
  如何参与: "Jak wziąć udział",
  币种充值: "Wpłata kryptowaluty",
  充值福利中领取福利: "Odbierz bonus przy bonusie za wpłatę",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Zasada: Bonus za wpłatę jest dobrowolny, ważny przez 24 godziny po wpłacie. Po odbiorze wypłata zostanie tymczasowo zablokowana do momentu osiągnięcia wymaganego obrotu.",
  失效日期: "Data wygaśnięcia",
  "暂无福利领取，充值后领取": "Brak dostępnego bonusu. Odbierz po wpłacie.",
  参与: "Weź udział",
  充值赠送: "Bonus za wpłatę",
  "领取*%的赠送": "Odbierz *% bonusu",
  去领取: "Odbierz",
  VIP奖励: "Nagroda VIP",
  "当前可领取*USDT，是否确认领取": "* USDT dostępne do odbioru. Potwierdzić?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Po odbiorze wypłata zostanie tymczasowo zablokowana do momentu osiągnięcia obrotu w wysokości * USDT.",
  充值送大礼: "Prezent za wpłatę",
  "存入越多，送越多！": "Im więcej wpłacisz, tym większy prezent!",
  无效: "Nieważne",
  有效: "Ważne",
  总存金额: "Całkowita wpłacona kwota",
  提示: "Uwaga",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Dodatnie liczby w całkowitym i netto zysku/straty oznaczają zysk platformy. Dane dzienne mają charakter orientacyjny.",
  "净盈亏：总盈亏-用户返水":
    "Wynik netto: Całkowity wynik - Cashback dla użytkownika",
  盈利方: "Strona z zyskiem",
  代理: "Agent",
  客户: "Klient",
  平局: "Remis",
  平台: "Platforma",
  "已提交审核，请耐心等待": "Wysłane do weryfikacji. Proszę czekać.",
  充值日期: "Data wpłaty",
  平台本月总输赢: "Całkowity zysk/strata platformy w tym miesiącu",
  KOL招募合作: "Współpraca rekrutacyjna KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Platforma otwiera rekrutację KOL. Z kontem w mediach społecznościowych możesz cieszyć się dywidendą i dożywotnim dochodem dzięki jednorazowemu pozyskiwaniu klientów.",
  级别: "Poziom",
  平台利润返佣: "Prowizja od zysku platformy",
  佣金案例: "Przykład prowizji",
  交易项目: "Produkty transakcyjne",
  "期权交易、合约交易、足球游戏":
    "Handel opcjami, handel kontraktami futures, gry piłkarskie",
  报名方式: "Sposób zapisu",
  点击KOL招募报名: "Kliknij, aby zapisać się na rekrutację KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Witamy w naszym zespole. Wspieramy Cię w budowaniu własnego systemu użytkowników. Zarób do *% prowizji. Czekamy na Twój udział.",
  输入联系方式: "Wprowadź dane kontaktowe",
  最低活跃人数: "Minimalna liczba aktywnych użytkowników",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Np.: Jeśli aktywni użytkownicy w tym miesiącu ≥ * a całkowity zysk/strata platformy ≥ * USDT, należysz do poziomu * i otrzymujesz *% prowizji.",
  比分竞猜: "Typowanie wyniku",
  豪礼相赠: "Wielki prezent",
  足球活动: "Aktywność piłkarska",
  圣诞节活动: "Aktywność świąteczna",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Wziąłeś udział w aktywności. Wypłata jest tymczasowo zablokowana. Potrzebujesz jeszcze * USDT obrotu, aby odblokować.",
  剩余流水: "Pozostały obrót",
  助力足球: "Wspieraj piłkę nożną",
  佣金累计: "Łączna prowizja",
  有效投注: "Ważne zakłady",
  今日: "Dzisiaj",
  今日返水: "Cashback dzisiaj",
  VIP返水: "Cashback VIP",
  返水记录: "Historia cashback",
  成员信息: "Informacje o członku",
  基本信息: "Podstawowe informacje",
  钱包余额: "Saldo portfela",
  投注信息: "Informacje o zakładzie",
  返水: "Cashback",
  总下注: "Łączny zakład",
  今日输赢: "Zysk/strata dzisiaj",
  下注动态: "Aktywność zakładów",
  返水奖励: "Nagroda cashback",
  分红金额: "Kwota dywidendy",
  返水支出: "Wydatek cashback",
  总返水: "Łączny cashback",
  流水总额: "Łączny obrót",
  返水总额: "Łączny cashback",
  返水详情: "Szczegóły cashback",
  日流水: "Dzienny obrót",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Platforma zapewnia dodatkowy cashback na podstawie dziennego obrotu Twoich niższych poziomów. Wypłata codziennie o 00:00 czasu singapurskiego na konto nagród.",
  "申请成功，等待审核": "Wniosek złożony pomyślnie, oczekuje na weryfikację",
  "我出本金，盈利共分享": "Ja daję kapitał, zysk jest dzielony",
  最高分红: "Maksymalna dywidenda",
  投资大师比赛: "Konkurs Mistrz Inwestor",
  "我出本金，你盈利": "Ja daję kapitał, Ty zarabiasz",
  共分享: "Dziel się razem",
  最高分红可得: "Maksymalna możliwa dywidenda",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Ekskluzywny bonus powitalny: $* gratis. Po odbiorze możesz inwestować w dowolny projekt. Zysk jest natychmiast wypłacalny.",
  报名领取: "Zapisz się i odbierz",
  审核驳回: "Weryfikacja odrzucona",
  驳回原因: "Przyczyna odrzucenia",
  活动运行周期: "Okres trwania aktywności",
  "申请成功后起至*天内完成超额收益。":
    "Osiągnij nadwyżkę zysku w ciągu * dni od zatwierdzenia.",
  分红比: "Wskaźnik dywidendy",
  "*日获得盈利后，可获得*%的收益额。":
    "Po osiągnięciu zysku w dniu *, otrzymujesz *% kwoty zysku.",
  参与条件: "Warunki uczestnictwa",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Użytkownicy z Rosji lub Turcji, którzy jeszcze nie uczestniczyli.",
  计算项目: "Obliczane produkty",
  "合约、体育、期权": "Kontrakty futures, Sport, Opcje",
  我的投资: "Moje inwestycje",
  参与天数: "Dni uczestnictwa",
  累计下注: "Łączny zakład",
  累计盈亏: "Łączny zysk/strata",
  预计可分红: "Oczekiwana dywidenda",
  常见问题: "Często zadawane pytania (FAQ)",
  什么是平台出资: "Co to jest finansowanie platformy?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Platforma zapewnia darmowe środki użytkownikom z określonych krajów do inwestowania w projekty.",
  怎么获取平台出资的福利: "Jak uzyskać bonus finansowania platformy?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Jeśli pochodzisz z jednego z określonych krajów, kliknij przycisk zapisu. Po zatwierdzeniu * USDT zostanie przeniesione na Twoje konto nagród, które możesz przenieść, aby zainwestować.",
  什么是分红: "Co to jest dywidenda?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dywidenda: Jeśli w określonym czasie zysk osiągnie 100%, otrzymujesz 50% nadwyżki zysku. Przykład: Otrzymujesz 100 USDT, osiągasz 120% zysku, wtedy 20% to nadwyżka.",
  "如何取得分红？": "Jak uzyskać dywidendę?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Cykl aktywności odbywa się co * dni. Po zakończeniu następuje rozliczenie. Jeśli spełniasz wymagania, dywidenda jest wysyłana na konto nagród. Jeśli nie, Twój zysk i finansowanie platformy zostaną usunięte.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Uczestniczące konta muszą być zweryfikowane KYC. Tylko jeden bonus na konto.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC do uczestnictwa jest ważne tylko dla określonych krajów. Sprawdź, czy Twój kraj odpowiada krajowi aktywności.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Po pomyślnym udziale wypłata zostanie tymczasowo zablokowana do czasu zakończenia aktywności.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Przestrzegaj zasad aktywności. W przypadku oszustwa lub nadużycia luk systemowych, wszystkie środki na Twoim koncie zostaną trwale zamrożone.",
  平台出资: "Finansowanie platformy",
  平台出资收回: "Finansowanie platformy cofnięte",
  投资大师奖励: "Nagroda Mistrza Inwestora",
  请下载APP添加收款方式: "Pobierz aplikację, aby dodać metodę odbioru",
  请下载APP进行身份验证:
    "Pobierz aplikację, aby przeprowadzić weryfikację tożsamości",
  请下载APP参与: "Pobierz aplikację, aby wziąć udział",
  技术指标: "Wskaźniki techniczne",
  主图: "Wykres główny",
  副图: "Wykres pomocniczy",
  新注册人数: "Nowe rejestracje",
  老用户存款人数: "Istniejący użytkownicy dokonujący wpłat",
  存款人数: "Liczba wpłat",
  取款人数: "Liczba wypłat",
  投注人数: "Liczba zakładów",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Z wyłączeniem użytkowników z Indonezji, Indii, Bangladeszu, którzy jeszcze nie uczestniczyli.",
  市场动态: "Dynamika rynku",
  外汇合约: "Kontrakty futures Forex",
  盈亏比: "Stosunek zysku do straty",
  委托价: "Cena zlecenia",
  可用余额: "Dostępne saldo",
  持仓额: "Wartość pozycji",
  强平价: "Cena likwidacji",
  修改: "Zmień",
  修改价位: "Zmień cenę",
  外汇: "Forex",
  外汇账户: "Konto Forex",
  我的交易: "Moje transakcje",
  未设置: "Nie ustawiono",
  超出最大可设数值: "Przekracza maksymalną ustawialną wartość",
  超出最小可设数值: "Poniżej minimalnej ustawialnej wartości",
  止盈超出最小可设数值: "Take-profit poniżej minimalnej ustawialnej wartości",
  止损超出最大可设数值: "Stop-loss przekracza maksymalną ustawialną wartość",
  止盈超出最大可设数值: "Take-profit przekracza maksymalną ustawialną wartość",
  止损超出最小可设数值: "Stop-loss poniżej minimalnej ustawialnej wartości",
  挖矿: "Wydobycie",
  交易账户: "Konto transakcyjne",
  买涨: "Kup (Long)",
  买跌: "Sprzedaj (Short)",
  请输入正确的银行卡信息: "Wprowadź poprawne dane karty bankowej",
  联系在线客服: "Skontaktuj się z czatem na żywo",
  法币交易请联系在线客服:
    "Skontaktuj się z obsługą klienta w sprawie handlu walutami fiducjarnymi",
  提交订单: "Złóż zamówienie",
  "支付过程如有疑问,请联系在线客服":
    "Skontaktuj się z obsługą klienta w razie pytań dotyczących procesu płatności",
  彩金赠送: "Przyznanie bonusu",
  在线客服: "Czat na żywo",
  最少投资: "Minimalna inwestycja",
  "提交时间:": "Czas wysłania:",
  提现拒绝: "Wypłata odrzucona",
  认证拒绝: "Weryfikacja odrzucona",
  认证通过: "Weryfikacja zatwierdzona",
  请输入正确的交易额度: "Wprowadź prawidłową kwotę transakcji",
  最大下注金额: "Maksymalny zakład",
  手机号: "Numer telefonu",
  邮箱注册: "Rejestracja przez e-mail",
  手机号注册: "Rejestracja przez numer telefonu",
  查询: "Zapytanie",
  手机号登录: "Zaloguj się przez numer telefonu",
  邮箱登录: "Zaloguj się przez e-mail",
  请输入数量: "Wprowadź ilość",
  可用数量: "Dostępna ilość",
  钱包登录: "Zaloguj się przez portfel",
  请输入正确的邀请码: "Wprowadź prawidłowy kod zaproszenia",
  "请输入邀请码(必填)": "Wprowadź kod zaproszenia (wymagane)",
  输入正确的金额: "Wprowadź prawidłową kwotę",
  法币充值: "Wpłata waluty fiducjarnej",
  卢比充值: "Wpłata rupii indyjskich",
  请输入法币: "Wprowadź kwotę waluty fiducjarnej",
  请输入IFSC: "Wprowadź kod IFSC",
  "银行编码(选填)": "Kod banku (opcjonalnie)",
  请输入银行编码: "Wprowadź kod banku",
  请输入大于8位数的密码: "Wprowadź hasło składające się z więcej niż 8 znaków",
  添加成功: "Dodano pomyślnie",
  "60秒": "60 sekund",
  "180秒": "180 sekund",
  "300秒": "300 sekund",
  "2次密码不一致": "Hasła nie są zgodne",
  输入提币数量: "Wprowadź ilość wypłaty",
  图片格式不正确: "Nieprawidłowy format obrazu",
  图片大于20M: "Obraz jest większy niż 20 MB",
  请设置委托价格: "Ustaw cenę zlecenia",
  输入资金密码: "Wprowadź hasło aktywów",
  验证码错误: "Nieprawidłowy kod weryfikacyjny",
  充值拒绝: "Wpłata odrzucona",
  请输入SSN: "Wprowadź numer SSN",
  结算完成: "Rozliczenie zakończone",
  继续下单: "Kontynuuj zamawianie",
  限价: "Zlecenie limitowane",
  买入价格: "Cena kupna",
  买入量: "Ilość kupna",
  卖出价格: "Cena sprzedaży",
  卖出量: "Ilość sprzedaży",
  买入: "Kup",
  卖出: "Sprzedaj",
  订单创建成功: "Zamówienie utworzone pomyślnie",
  币币买入支出: "Wydatek na zakup spot",
  币币买入支出退还: "Zwrot wydatku na zakup spot",
  币币买入获得: "Uzyskane z zakupu spot",
  币币卖出支出: "Wydatek na sprzedaż spot",
  币币卖出支出退还: "Zwrot wydatku na sprzedaż spot",
  币币卖出获得: "Uzyskane ze sprzedaży spot",
  币币交易手续费: "Opłata transakcyjna spot",
  请输入限价: "Wprowadź cenę limitowaną",
  成交: "Wykonane",
  等待成交: "Oczekuje na wykonanie",
  交易完成: "Transakcja zakończona",
  被取消: "Anulowane",
  交易时间: "Czas transakcji",
  法币交易: "Transakcja walutą fiducjarną",
  法币出售: "Sprzedaż waluty fiducjarnej",

  两次密码不一致: "Hasła nie są zgodne",
  再次输入账户密码: "Wprowadź ponownie hasło konta",

  美国: "Stany Zjednoczone",
  韩国: "Korea Południowa",
  阿尔巴尼亚: "Albania",
  津巴布韦: "Zimbabwe",
  赞比亚: "Zambia",
  也门: "Jemen",
  美属维尔京群岛: "Wyspy Dziewicze Stanów Zjednoczonych",
  英属处女群岛: "Brytyjskie Wyspy Dziewicze",
  越南: "Wietnam",
  委内瑞拉: "Wenezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Uzbekistan",
  乌拉圭: "Urugwaj",
  英国: "Wielka Brytania",
  阿拉伯联合酋长国: "Zjednoczone Emiraty Arabskie",
  乌克兰: "Ukraina",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Turks i Caicos",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Turcja",
  突尼斯: "Tunezja",
  特立尼达和多巴哥: "Trynidad i Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Timor Wschodni",
  泰国: "Tajlandia",
  坦桑尼亚: "Tanzania",
  塔吉克斯坦: "Tadżykistan",
  中国台湾: "Tajwan",
  叙利亚: "Syria",
  瑞士: "Szwajcaria",
  瑞典: "Szwecja",
  斯威士兰: "Eswatini",
  苏里南: "Surinam",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Hiszpania",
  南非: "Republika Południowej Afryki",
  索马里: "Somalia",
  所罗门群岛: "Wyspy Salomona",
  斯洛文尼亚: "Słowenia",
  斯洛伐克: "Słowacja",
  "圣马丁岛（荷兰部分）": "Sint Maarten (część holenderska)",
  新加坡: "Singapur",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seszele",
  塞尔维亚: "Serbia",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Arabia Saudyjska",
  圣多美和普林西比: "Wyspy Świętego Tomasza i Książęca",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Saint Kitts i Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent i Grenadyny",
  圣彼埃尔和密克隆岛: "Saint-Pierre i Miquelon",
  圣露西亚: "Saint Lucia",
  圣基茨和尼维斯: "Saint Kitts i Nevis",
  卢旺达: "Rwanda",
  俄罗斯: "Rosja",
  罗马尼亚: "Rumunia",
  留尼汪: "Reunion",
  刚果共和国: "Republika Konga",
  卡塔尔: "Katar",
  波多黎各: "Portoryko",
  葡萄牙: "Portugalia",
  波兰: "Polska",
  菲律宾: "Filipiny",
  秘鲁: "Peru",
  巴拉圭: "Paragwaj",
  巴布亚新几内亚: "Papua-Nowa Gwinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palestyna",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Norwegia",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nikaragua",
  新西兰: "Nowa Zelandia",
  新喀里多尼亚: "Nowa Kaledonia",
  荷属安德列斯群岛: "Antyle Holenderskie",
  荷兰: "Holandia",
  尼泊尔: "Nepal",
  纳米比亚: "Namibia",
  缅甸: "Mjanma",
  莫桑比克: "Mozambik",
  摩洛哥: "Maroko",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Czarnogóra",
  蒙古: "Mongolia",
  摩纳哥: "Monako",
  摩尔多瓦: "Mołdawia",
  墨西哥: "Meksyk",
  马约特: "Majotta",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauretania",
  马里亚纳群岛: "Mariany",
  马提尼克: "Martynika",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Malediwy",
  马来西亚: "Malezja",
  马拉维: "Malawi",
  马达加斯加: "Madagaskar",
  马其顿: "Macedonia Północna",
  中国澳门: "Makau",
  卢森堡: "Luksemburg",
  立陶宛: "Litwa",
  列支敦士登: "Liechtenstein",
  利比亚: "Libia",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Liban",
  拉脱维亚: "Łotwa",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirgistan",
  科威特: "Kuwejt",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenia",
  哈萨克斯坦: "Kazachstan",
  约旦: "Jordania",
  日本: "Japonia",
  牙买加: "Jamajka",
  象牙海岸: "Wybrzeże Kości Słoniowej",
  意大利: "Włochy",
  以色列: "Izrael",
  爱尔兰: "Irlandia",
  伊拉克: "Irak",
  伊朗: "Iran",
  印度尼西亚: "Indonezja",
  印度: "Indie",
  冰岛: "Islandia",
  匈牙利: "Węgry",
  中国香港: "Hongkong",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Gujana",
  几内亚比绍共和国: "Gwinea Bissau",
  几内亚: "Gwinea",
  危地马拉: "Gwatemala",
  关岛: "Guam",
  瓜德罗普岛: "Gwadelupa",
  格林纳达: "Grenada",
  格陵兰岛: "Grenlandia",
  希腊: "Grecja",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Niemcy",
  格鲁吉亚: "Gruzja",
  冈比亚: "Gambia",
  加蓬: "Gabon",
  法属波利尼西亚: "Polinezja Francuska",
  法属圭亚那: "Gujana Francuska",
  法国: "Francja",
  芬兰: "Finlandia",
  斐济: "Fidżi",
  法罗群岛: "Wyspy Owcze",
  埃塞俄比亚: "Etiopia",
  爱沙尼亚: "Estonia",
  厄立特里亚: "Erytrea",
  赤道几内亚: "Gwinea Równikowa",
  萨尔瓦多: "Salwador",
  埃及: "Egipt",
  厄瓜多尔: "Ekwador",
  多米尼加共和国: "Dominikana",
  多米尼加: "Dominika",
  吉布提: "Dżibuti",
  丹麦: "Dania",
  捷克: "Czechy",
  塞浦路斯: "Cypr",
  库拉索: "Curaçao",
  古巴: "Kuba",
  克罗地亚: "Chorwacja",
  哥斯达黎加: "Kostaryka",
  科特迪瓦: "Wybrzeże Kości Słoniowej",
  库克群岛: "Wyspy Cooka",
  科摩罗: "Komory",
  哥伦比亚: "Kolumbia",
  智利: "Chile",
  乍得: "Czad",
  中非共和国: "Republika Środkowoafrykańska",
  佛得角: "Republika Zielonego Przylądka",
  开曼群岛: "Kajmany",
  开普: "Cape",
  加拿大: "Kanada",
  喀麦隆: "Kamerun",
  柬埔寨: "Kambodża",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bułgaria",
  文莱: "Brunei",
  巴西: "Brazylia",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bośnia i Hercegowina",
  玻利维亚: "Boliwia",
  不丹: "Bhutan",
  百慕大群岛: "Bermudy",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belgia",
  白俄罗斯: "Białoruś",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesz",
  巴林: "Bahrajn",
  巴哈马: "Bahamy",
  阿塞拜疆: "Azerbejdżan",
  奥地利: "Austria",
  澳大利亚: "Australia",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenia",
  阿根廷: "Argentyna",
  安提瓜和巴布达: "Antigua i Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andora",
  美属萨摩亚: "Samoa Amerykańskie",
  阿尔及利亚: "Algieria",
  中国: "Chiny",
  余额不足: "Niewystarczające saldo",
  最低购买: "Minimalny zakup",
  最高购买: "Maksymalny zakup",
  下单成功: "Zamówienie złożone pomyślnie",
  平仓成功: "Pozycja zamknięta pomyślnie",
  请输入正确的平仓数量: "Wprowadź prawidłową ilość do zamknięcia",
  加仓成功: "Pozycja zwiększona pomyślnie",
  请输入正确的加仓金额: "Wprowadź prawidłową kwotę zwiększenia pozycji",
  收藏成功: "Dodano do ulubionych",
  取消收藏成功: "Usunięto z ulubionych",
  加密币永续: "Perpetual kryptowalutowy",
  外汇永续: "Perpetual Forex",
  期权账户: "Konto opcji",
  快捷卖币: "Szybka sprzedaż kryptowaluty",

  托管资金: "Zarządzane środki",
  托管中: "W zarządzaniu",
  预计日收益: "Szacowany dzienny zysk",
  累计收益: "Całkowity zysk",
  周期: "Okres",
  日收益: "Dzienny zysk",
  限额: "Limit",
  立即托管: "Rozpocznij zarządzanie teraz",
  "已鎖定 請聯繫客服": "Zablokowane. Skontaktuj się z obsługą klienta.",
  产品列表: "Lista produktów",
  规则: "Zasady",
  创建订单: "Utwórz zamówienie",
  产品名称: "Nazwa produktu",
  托管周期: "Okres zarządzania",
  等级限制: "Ograniczenie poziomu",
  托管金额: "Zarządzana kwota",
  限额: "Limit",
  余额: "Saldo",
  购买日: "Data zakupu",
  起息日: "Data rozpoczęcia naliczania odsetek",
  派息时间: "Czas wypłaty odsetek",
  每天: "Codziennie",
  计息结束日: "Data zakończenia naliczania odsetek",
  每日收益: "Dzienny zysk",
  预计收益: "Szacowany zysk",
  "收益将自动发送至您的余额账户;":
    "Zysk zostanie automatycznie wysłany na saldo Twojego konta;",
  "您的资金没有任何风险;": "Twoje środki nie są narażone na ryzyko;",
  "365*24小时不断地工作;": "Pracuje 24/7, 365 dni w roku;",
  托管中: "W zarządzaniu",
  结束: "Zakończone",
  今日收益: "Dzisiejszy zysk",
  剩余周期: "Pozostały okres",
  进行中: "Aktywny",
  已发放: "Wypłacone",
  信誉分: "Punkty reputacji",

  复制成功: "Skopiowano pomyślnie",
  VIP权益: "Korzyści VIP",
  旧密码: "Stare hasło",
  请输入旧密码: "Wprowadź stare hasło",
  "忘记旧密码请联系客服重置。":
    "Jeśli zapomniałeś starego hasła, skontaktuj się z obsługą klienta, aby je zresetować.",
  去升级: "Przejdź do aktualizacji",
  描述: "Opis",
  实际存款金额: "Rzeczywista kwota depozytu",
  升级礼金: "Bonus za aktualizację",
  隔夜利息: "Odsetki za noc (swap)",
  自动结算: "Automatyczne rozliczenie",
  等级规则: "Zasady poziomów",
  "WEB3.0币持有数据收益": "Zysk z danych posiadania monet WEB3.0",
  总生产: "Całkowita produkcja",
  有效节点: "Aktywne węzły",
  参与人: "Uczestnicy",
  用户收益: "Zysk użytkownika",
  "流动性WEB3.0输出": "Wyjście płynności WEB3.0",
  总资产: "Aktywa ogółem",

  ETHAI持有数据收益: "Zysk z posiadania danych ETHAI",
  AI量化流动性: "Płynność AI ilościowa",
  现货买入手续费: "Opłata za zakup spot",
  现货支出: "Wydatek spot",
  现货资金费率: "Stopa finansowania spot",
  现货卖出手续费: "Opłata za sprzedaż spot",
  现货收入: "Przychód spot",
  外汇合约支出: "Wydatek na kontrakt walutowy",
  外汇合约买入手续费: "Opłata za zakup kontraktu walutowego",
  外汇合约资金费率: "Stopa finansowania kontraktu walutowego",
  外汇合约卖出手续费: "Opłata za sprzedaż kontraktu walutowego",
  外汇合约收入: "Przychód z kontraktu walutowego",
  理财购买: "Zakup produktu inwestycyjnego",
  VIP理财日收益: "Dzienny zysk z VIP produktu inwestycyjnego",
  VIP理财隔夜利息: "Odsetki overnight od VIP produktu inwestycyjnego",
  VIP本金返还: "Zwrot kapitału VIP",
  VIP彩金发放: "Wypłata bonusu VIP",
  VIP彩金抵扣: "Potrącenie bonusu VIP",
  隔夜利息: "Odsetki overnight",
  设置资产密码: "Ustaw hasło do aktywów",

  锁仓挖矿: "Kopanie z blokadą",
  一站式理财服务: "Kompleksowa usługa finansowa",
  产品: "Produkty",
  客服中心: "Centrum obsługi klienta",
  贷款: "Pożyczki",
  挖矿赚不停: "Nieprzerwane zyski z kopania",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Kopanie z blokadą polega na powierzeniu USDT (USD:1USDT=1USD) superwydajnym koparkom platformy w celu uzyskiwania zysków z wydobycia w puli wydobywczej platformy.",
  产品优势: "Zalety produktu",
  随存随取: "Wpłaty i wypłaty w dowolnym momencie",
  锁仓周期: "Okres blokady",
  每日下发: "Codzienna wypłata",
  随机空投: "Losowy airdrop",
  "100%资金安全保障": "100% gwarancji bezpieczeństwa środków",
  "100%节假日收益不间断": "100% ciągłości zysków nawet w święta",
  成功锁仓后当天产出:
    "Zyski naliczane tego samego dnia po skutecznej blokadzie",
  关于违约金: "O karze umownej",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Jeśli chcesz wypłacić kapitał przed terminem, zostanie naliczona kara umowna. Kara umowna = współczynnik rozliczenia kary × pozostałe dni × kwota blokady.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Przykład: Współczynnik rozliczenia kary dla tego produktu wynosi 5%, do końca pozostały 3 dni, a kwota blokady wynosi 10000U (USDT/USD). Wówczas kara umowna = 5%×3×10000=1500U, a rzeczywiście zwrócony kapitał wynosi 15000U-1500U.",
  收益计算: "Obliczanie zysków",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Platforma oferuje różne produkty finansowe kopania z blokadą. Obliczanie zysków wygląda następująco, na przykład:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Jeśli użytkownik zablokuje na platformie 10000U (USDT, USD) i wybierze produkt finansowy na 7 dni z dziennym zyskiem 0,7%~1,8% kwoty blokady, dzienny dochód będzie wyglądał następująco:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maksimum: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Po 7 dniach można uzyskać zysk od 490U do 1260U. Zyski są wypłacane codziennie, a po zakończeniu okresu blokady kapitał zostanie automatycznie przelany na konto finansowe.",
  正在托管的资金: "Środki w zarządzaniu",
  签到: "Zameldowanie",
  锁仓订单: "Zamówienia blokady",
  预计今日收益: "Przewidywany dzisiejszy zysk",
  累计收益: "Łączny zysk",
  托管中的订单: "Zamówienia w zarządzaniu",
  单笔最少: "Minimalna kwota pojedynczej transakcji",
  单笔最多: "Maksymalna kwota pojedynczej transakcji",
  日收益率: "Dzienna stopa zwrotu",
  说明: "Opis",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Statystyki są prowadzone według czasu GMT+8<br>2. Dzienne zyski obliczane są na podstawie wszystkich rozliczonych zamówień między 00:00-23:59 GMT+8 (czas lokalny 00:00-23:59)<br>3. Dzienne zyski będą wypłacane następnego dnia między 00:00-00:10 GMT+8.",
  知道了: "Rozumiem",
  锁仓: "Blokada",
  派息时间: "Czas wypłaty odsetek",
  每日: "Codziennie",
  托管资金: "Środki w zarządzaniu",
  到期返回: "Zwrot po terminie",
  提前赎回: "Wcześniejszy wykup",
  预计收益: "Przewidywany zysk",
  认购: "Subskrypcja",
  热门: "Popularne",
  数字货币: "Waluty cyfrowe",
  贵金属: "Metale szlachetne",
  大宗商品: "Towary masowe",
  持仓明细: "Szczegóły pozycji",
  历史明细: "Historia",
  当前价: "Aktualna cena",
  "↑买涨": "↑ Kup wzrost",
  "↓买跌": "↓ Kup spadek",
  显示全部: "Pokaż wszystko",
  买入金额: "Kwota zakupu",
  方向: "Kierunek",
  收益: "Zysk",
  预期收益: "Przewidywany zysk",
  估用保证金: "Szacowany depozyt zabezpieczający",
  确认下单: "Potwierdź zamówienie",
  锁定: "Zablokowane",
  账户总资产: "Łączne aktywa konta",
  明细: "Szczegóły",
  今日收益: "Dzisiejszy zysk",
  仓位保证金: "Depozyt zabezpieczający pozycji",
  持有仓位: "Posiadane pozycje",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Zablokowana kwota = suma wszystkich niezakończonych zamówień kopania z blokadą",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Statystyki są prowadzone według czasu GMT+8<br>2. Dzienne zyski obliczane są na podstawie wszystkich rozliczonych zamówień między 00:00-23:59 GMT+8 (czas lokalny 00:00-23:59)",
  充值方式: "Metoda wpłaty",
  银行汇款: "Przelew bankowy",
  "银行汇款请联系客服进行操作!":
    "Skontaktuj się z obsługą klienta w celu wykonania przelewu bankowego!",
  提款方式: "Metoda wypłaty",
  "银行提款请联系客服进行操作!":
    "Skontaktuj się z obsługą klienta w celu wykonania wypłaty bankowej!",
  资金明细: "Szczegóły środków",
  提现记录: "Historia wypłat",
  拒绝: "Odrzucono",
  通过: "Zatwierdzono",
  拒绝原因: "Powód odrzucenia",

  消息公告: "Ogłoszenia",
  订单: "Zamówienia",
  个人中心: "Centrum osobiste",
  "未到期赎回需支付一定的违约金!":
    "W przypadku wcześniejszego wykupu należy zapłacić karę umowną.",

  请输入区号: "Wprowadź numer kierunkowy",
  "请选择国家/地区": "Wybierz kraj/region",

  今日开盘: "Dzisiejsze otwarcie",
  昨日收盘: "Wczorajsze zamknięcie",

  实名认证即送: "Otrzymaj natychmiast po weryfikacji tożsamości",
  立即认证: "Zweryfikuj teraz",
  新用户礼包: "Pakiet powitalny dla nowych użytkowników",
  完成新人任务领取: "Wykonaj zadania dla nowych użytkowników, aby odebrać",
  认证: "Weryfikacja",
  时间周期: "Okres czasu",
  支付金额: "Kwota płatności",
  已平仓: "Pozycja zamknięta",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "Pakiet powitalny MGBX dla nowych użytkowników: każdy użytkownik może otrzymać maksymalnie",
  我已经阅读并同意: "Przeczytałem(-am) i zgadzam się z",
  隐私政策: "Polityka prywatności",

  放弃奖励离开: "Zrezygnuj z nagrody i opuść",
  继续注册: "Kontynuuj rejestrację",
  分钟: "Minuty",
  "请先勾选隐私政策!": "Proszę najpierw zapoznać się z Polityką prywatności!",
  添加其他到自选: "Dodaj inne do listy obserwowanych",
  充值最高可得: "Doładuj konto i otrzymaj nawet 30 000 USD.",

  请输入格式正确的手机号: "Proszę podać prawidłowy numer telefonu komórkowego.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 波兰



// WEBPACK FOOTER //
// ./src/lang/bl.js